import {Provider as ReduxProvider} from 'react-redux'
import {BrowserRouter} from 'react-router-dom'
import {PersistGate} from 'redux-persist/integration/react'
import store, {persistor} from './store'
import Theme from '@/components/template/Theme'
import Layout from '@/components/layouts'
import ErrorBoundary from '@/components/ui/ErrorBoundary.jsx'
import './locales'
import {SessionProvider} from './features/context/SessionContext'
import {MyThemeProvider} from './features/context/ThemeContext'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import React, {useEffect} from "react";

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import 'react-spring-bottom-sheet/dist/style.css'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import {createRoot} from "react-dom/client";
import {BUILD_TYPE} from "@/constants/app.constant";


// Fix leaflet's default icon issue
delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});


// const environment = process.env.NODE_ENV

// if (appConfig.enableMock) {
//     mockServer({environment})
// }

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10 * 1000,
            // staleTime: 0,
        },
    },
})

const patchNodeMethods = () => {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function (child: Node) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments as unknown as [Node]);
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function (newNode: Node, referenceNode: Node | null) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments as unknown as [Node, Node | null]);
        };
    }
};


// import { registerSW } from "virtual:pwa-register";
//
// export const updateSW = registerSW({
//     immediate: true,
//     onNeedRefresh() {
//         window.location.reload();
//     },
//     onOfflineReady() {
//         // console.log("App ready offline");
//     },
// });
//
// // updateSW();

function App() {
    useEffect(() => {
        patchNodeMethods();
    }, [])

    return (
        <QueryClientProvider client={queryClient}>
            <ReduxProvider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <SessionProvider>
                            <MyThemeProvider>
                                <Theme>
                                    <ErrorBoundary>
                                        <Layout/>
                                    </ErrorBoundary>
                                </Theme>
                            </MyThemeProvider>
                        </SessionProvider>
                    </BrowserRouter>
                </PersistGate>
            </ReduxProvider>
        </QueryClientProvider>
    )
}

export default App
